module.exports = __webpack_public_path__ + "static/img/settleln2.a75c9a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/settleln2.png
// module id = P20d
// module chunks = 1